/*
 * Copyright (c) 2019 LNBIG.com
 * All rights reserved.
 */

import Vue from 'vue'
import App from '@/App.vue'
import vuetify from '@/plugins/vuetify'
import Vuex from 'vuex';
import nodeListArray from '@/NodeFlatString.js';
import VueClipboard from 'vue-clipboard2'
import {VueReCaptcha} from 'vue-recaptcha-v3'
import browserDetect from "vue-browser-detect-plugin"
import pTimeout from 'p-timeout'
import QrcodeVue from 'qrcode.vue'

import VueNativeSock from 'vue-native-websocket'
import createPersistedState from 'vuex-persistedstate'

import openChannel from '@/storeModules/OpenChannel'
import main        from '@/storeModules/Main'
import chat        from '@/storeModules/Chat'
import addMerchant from '@/storeModules/AddMerchant'

import VueRouter from 'vue-router'

import RouterHome        from '@/components/RouterHome'
import RouterAbout       from '@/components/RouterAbout'
import RouterOpenChannel from '@/components/RouterOpenChannel'
import RouterOurNodes    from '@/components/RouterOurNodes'
import RouterChat        from '@/components/RouterChat'
//import RouterAddMerchant from '@/components/RouterAddMerchant'

import OpenChannelWizard from '@/components/OpenChannelWizard'
import CardNode          from '@/components/CardNode'
import PreChat           from '@/components/PreChat'
import SnackBar          from '@/components/snackBar'
import LnbigQrCode       from '@/components/LnbigQrCode'
import ShareButton       from "@/components/ShareButton"

import dbg from 'debug'

const debug = dbg('lnbig:main')

debug('chat module is %o', chat)

Vue.config.productionTip = false

Vue.use(Vuex)
Vue.use(VueClipboard)
Vue.use(VueReCaptcha, {siteKey: process.env.VUE_APP_GOOGLE_RECAPTCHA_V3_SITE_KEY, loaderOptions: {useRecaptchaNet: false}})
Vue.use(browserDetect)

debug('Site key for reCaptcha v3: %s', process.env.VUE_APP_GOOGLE_RECAPTCHA_V3_SITE_KEY)

Vue.use(VueRouter)

Vue.component('open-channel-wizard', OpenChannelWizard)
Vue.component('pre-chat', PreChat)
Vue.component('card-node', CardNode)
Vue.component('snack-bar', SnackBar)
Vue.component('qrcode-vue', QrcodeVue)
Vue.component('lnbig-qr-code', LnbigQrCode)
Vue.component('share-button', ShareButton)

const routes = [
    {path: '/', component: RouterHome, props: (route) => ({oc_uuid: route.query.oc_uuid || null})},
    {path: '/chat', component: RouterChat},
    {path: '/our-nodes', component: RouterOurNodes},
    {path: '/about', component: RouterAbout},
    {path: '/open-channel', component: RouterOpenChannel, props: (route) => ({oc_uuid: route.query.oc_uuid || null})},
//    {path: '/add-merchant', component: RouterAddMerchant},
];

const router = new VueRouter({
    routes // сокращённая запись для `routes: routes`
})

let app,
    _socketPromiseResolve,
    _socketPromiseReject,
    modules = {
        openChannel,
        main,
        chat,
        addMerchant
    }

const store = new Vuex.Store({
    state: {
        nodeList: [],
        webSocket: null,
        wsConnectPromise: null,
        helloPromise: null,
        webSocketError: null,
        connectionCounter: 0,
    },
    mutations: {
        loadNodeList(state) {
            console.log("load nodes...")
            state.nodeList = nodeListArray;
            console.log(['nodes', nodeListArray]);
        },
        setWebSocketError(state, error) {
            state.webSocketError = error
        },
        setWsConnectPromise(state, promise) {
            state.wsConnectPromise = promise
        },
        setHelloPromise(state, promise) {
            state.helloPromise = promise
        },
        SOCKET_ONOPEN(state, event) {
            debug('SOCKET_ONOPEN: state: %o, ws: %o', state, event.currentTarget);
            state.webSocket      = event.currentTarget
            state.webSocketError = null

            state.connectionCounter++

            if (_socketPromiseResolve) {
                _socketPromiseResolve(state.webSocket)
                _socketPromiseReject = _socketPromiseResolve = null
            }
        },
        SOCKET_ONCLOSE(state) {
            state.webSocket = null
            state.webSocketError = 'No connect with server. Reconnecting...'
            debug('Close - reconnecting')

            state.wsConnectPromise = pTimeout(
                new Promise(function (resolve, reject) {
                    _socketPromiseResolve = resolve
                    _socketPromiseReject  = reject
                }),
                12000,
                () => {
                    _socketPromiseReject = _socketPromiseResolve = null
                    app.$disconnect()
                    state.webSocketError = "Server connect timed out. Please try later!"
                    throw new Error(state.webSocketError)
                }
            )
        },
        SOCKET_ONERROR(state) {
            state.webSocket = null
            state.webSocketError = 'Some communication error. Please try to reload page!'

            if (_socketPromiseReject) {
                _socketPromiseReject(new Error(state.webSocketError))
                _socketPromiseReject = _socketPromiseResolve = null
            }
        }
    },
    modules,
    plugins: [
        createPersistedState({paths: ['main', 'chat.nick']}),
        store => {
            store.watch(
                state => state.openChannel.openChannelInfo.lnurl,
                (newLnurl, oldLnurl) => {
                    debug('watch lnurl (start of countdown timer), changed from %s to %s', oldLnurl, newLnurl)
                    store.commit('openChannel/setStartTimeForLnurlCountdown')
                }
            )
            store.watch(
                state => state.openChannel.prepayment.invoice,
                (newLnurl, oldLnurl) => {
                    debug('watch prepayment (start of countdown timer), changed from %s to %s', oldLnurl, newLnurl)
                    store.commit('openChannel/setStartTimeForPrepaymentCountdown')
                }
            )
        }
    ]
})

store.subscribe((mutation, state) => {
    if (mutation.type === 'SOCKET_ONOPEN') {
        store.commit('setHelloPromise', store.dispatch('main/actHelloAndUserID'))
        for (module in modules) {
            if (modules[module].state.hasOwnProperty('reCaptchaV3')) {
                // Сбрасываем капчи, так как после пересоединения надо снова их заново проходить
                store.commit(`${module}/setReCaptchaV3Promise`, null)
                store.commit(`${module}/setReCaptchaV2Promise`, null)
            }
        }
   }
})

// Объект store здесь уже создан, плагин восстановления состояния должен восстановить state из localStorage

debug(`origin is ${document.domain}`)
debug(`base_url for socket: ${process.env.VUE_APP_WS_BASE_URL}`)

Vue.use(
    VueNativeSock,
    process.env.VUE_APP_WS_BASE_URL,
    {
        store: store,
        format: 'json',
        reconnection: true,
        connectManually: true,
    }
)

store.commit('loadNodeList');

app = (new Vue({
    render: h => h(App),
    store,
    router,
    vuetify
}))

store.commit('setWsConnectPromise', pTimeout(
    new Promise(function (resolve, reject) {
        _socketPromiseResolve = resolve
        _socketPromiseReject  = reject
        // Здесь уже запускается коннект к сокету - на данный момент состояние store.state уже должно быть восстановленным из localStorage
        app.$connect()
    }),
    12000,
    () => {
        _socketPromiseReject = _socketPromiseResolve = null
        app.$disconnect()
        store.commit('setWebSocketError', "Server connect timed out. Please try later!")
        return Promise.reject(new Error(store.state.webSocketError))
    }
))

app.$mount('#app')
